module.exports = __webpack_public_path__ + "img/list8.8e4fff57.png";